import { render, staticRenderFns } from "./PageEdit.vue?vue&type=template&id=490621ea&"
import script from "./PageEdit.vue?vue&type=script&lang=js&"
export * from "./PageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('490621ea')) {
      api.createRecord('490621ea', component.options)
    } else {
      api.reload('490621ea', component.options)
    }
    module.hot.accept("./PageEdit.vue?vue&type=template&id=490621ea&", function () {
      api.rerender('490621ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/page/PageEdit.vue"
export default component.exports